<template>
  <div class="kudos-thank">
    <h6 v-if="title" class="font-weight-bold">{{title}}</h6>
    <div class="kudos-thank-content">
      <span>
        <kudos-alt-icon class="kudos-thank-kudos shadow-filter-sm" />
        {{kudos}}
      </span>
      <span class="ml-4">
        <thank-icon />
        {{thank}}
      </span>
    </div>
  </div>
</template>

<script>
import KudosAltIcon from '@/assets/images/kudos-alt.svg'
import ThankIcon from '@/assets/images/thank.svg'

export default {
  name: 'KudosThank',

  props: {
    title: {
      type: String
    },

    kudos: {
      type: Number,
      default: 0
    },

    thank: {
      type: Number,
      default: 0
    }
  },

  components: {
    KudosAltIcon,
    ThankIcon
  }
}
</script>
